import { render, staticRenderFns } from "./NewBg.vue?vue&type=template&id=1b193dc4&scoped=true&"
import script from "./NewBg.vue?vue&type=script&lang=js&"
export * from "./NewBg.vue?vue&type=script&lang=js&"
import style0 from "./NewBg.vue?vue&type=style&index=0&lang=css&"
import style1 from "./NewBg.vue?vue&type=style&index=1&id=1b193dc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b193dc4",
  null
  
)

export default component.exports